import {NavLink as RouterLink,matchPath,useLocation} from 'react-router-dom';
import PropTypes from 'prop-types';
import { Button, ListItem,Avatar } from '@material-ui/core';
import { makeStyles, useTheme } from "@material-ui/core/styles";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { history } from "../components/helpers/History";
import { useDispatch } from "react-redux";
import { UserActions } from "../redux/actions/UserActions";

const useStyles = makeStyles((theme) => ({
  contentActive : {
    background : theme.navbar.activeNav.color,
    color : theme.navbar.activeNav.contrastText,
    '&:hover': {
      background : theme.navbar.activeNav.color,
      color : theme.navbar.activeNav.contrastText,
    },
  },
  iconContentActive : {
    color : theme.navbar.activeNav.contrastText,
    '&:hover': {
      color : theme.navbar.activeNav.contrastText,
    },
  },
  iconContent : {
    color : theme.navbar.background.contrastText,
    '&:hover': {
      color : theme.navbar.background.contrastText,
    },
  }
}));

const NavItem = ({href,icon: Icon,title,fontAwesomeIcon,...rest}) => {
  const location = useLocation();
  const classes = useStyles();
  const theme = useTheme();
  const match = matchPath(location.pathname, {path: href,exact: true,strict: false});
  const active = (match && match.isExact) ? true : false;
  const dispatch = useDispatch();

  return (
    <ListItem button className={active?classes.contentActive:classes.iconContent}
      onClick={() => {
        if(href==="/login"){
          dispatch(UserActions.logout());
        }else{
          history.push(href);
        }
      }}
      >
        <ListItemIcon className={active?classes.iconContentActive:classes.iconContent}>
          {Icon && (
            <Icon />
          )}
          {fontAwesomeIcon &&(
            <i className={`fas fa-${fontAwesomeIcon}`}></i>
            
          )}
        </ListItemIcon>
        <ListItemText primary={title} />
      </ListItem>
  );
};

NavItem.propTypes = {
  href: PropTypes.string,
  icon: PropTypes.elementType,
  title: PropTypes.string
};

export default NavItem;
